<template>
    <vRecyleListComponent v-if="flag" :postList="postList"></vRecyleListComponent>
</template>
<script>
import vRecyleListComponent from '../listComponent/recycle/recycleComponent.vue';
export default {
    name: 'recycleList',
    components: {
        vRecyleListComponent
    },
    data() {
        return {
            flag: false,
            postList: {
                headerTitle: false,
                is_self: true,
                rel_type: true,
                value1: true,
                clearBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            }
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>